import { action, observable, makeObservable } from 'mobx';
import { RemoteResourceV3, updateRemoteResourceV3 } from '../../../../../commonv3/api/RemoteResourceV3';
import { SessionShowView } from '../../../../types/sessions';
import { SessionId } from '../../../../../commonv3/types/sessions';
import { SessionApis } from '../../../../apis/sessions';

export class SessionReservationCompletePaneState {
  sessionId: SessionId | null = null;
  session: RemoteResourceV3<SessionShowView> = RemoteResourceV3.loading();
  submitting = false;

  constructor() {
    makeObservable(this, {
      sessionId: observable,
      session: observable,
      submitting: observable,
      init: action.bound,
      reloadSession: action.bound,
    });
  }

  async init(sessionId: SessionId): Promise<void> {
    this.sessionId = sessionId;
    this.reloadSession();
  }

  async reloadSession() {
    await updateRemoteResourceV3(
      this.session,
      (v) => (this.session = v),
      () => {
        if (!this.sessionId) {
          throw new Error('SessionReservationCompletePaneState is not initialized');
        }
        return SessionApis.show(this.sessionId);
      }
    );
  }
}
